import { HStack } from "@zenchef/styled-system/jsx";
import { Tag } from "./types";
import Icon from "../Icon/Icon";
import TagComponent from "../Tag/Tag";
import Button from "../Button/Button";
import { getSelectedTags } from "./utils";
import { BaseFilterProps } from "./BaseFilter";

export interface FilterTagsProps
  extends Pick<BaseFilterProps, "items" | "sections"> {
  values?: string[];
  tags?: Tag[];
  clearAllValuesLabel?: string;
  onClearAllValues?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onClearValue?: (
    event: React.MouseEvent<HTMLElement>,
    { name, value }: { name?: string; value: string },
  ) => void;
}

const FilterTags = ({
  values,
  tags,
  items,
  sections,
  clearAllValuesLabel,
  onClearAllValues,
  onClearValue,
}: FilterTagsProps) => {
  const selectedTags: Tag[] = getSelectedTags({
    values,
    tags,
    items,
    sections,
  });

  if (!selectedTags.length) {
    return null;
  }

  return (
    <HStack gap="gap.1" flexWrap="wrap">
      {selectedTags.map(({ value, label, filterName }) => (
        <TagComponent
          key={value}
          hierarchy="subtle"
          colorTheme="brand"
          maxHeight="s"
        >
          {label}
          {onClearValue ? (
            <Icon
              name="x"
              color="content.brand.subtle"
              cursor="pointer"
              onClick={(event) =>
                onClearValue(event, { name: filterName, value })
              }
            />
          ) : null}
        </TagComponent>
      ))}
      {clearAllValuesLabel && onClearAllValues ? (
        <Button
          height="s"
          borderRadius="s"
          hierarchy="secondary-subtler"
          onClick={onClearAllValues}
        >
          {clearAllValuesLabel}
        </Button>
      ) : null}
    </HStack>
  );
};

export default FilterTags;
